<template>
	<div class="shop-promo">
    <cart-menu-button>
      <template v-if="quantity > 0">
        <v-list slot="cart-items" three-line dense width="300">
          <cart-item :readOnlyQuantity="!allowMultiplePurchase">
            <v-btn
							v-if="allowMultiplePurchase"
              slot="decrease-button"
              icon
              @click="decreaseQuantity()"
            >
              <v-icon large color="primary">mdi-minus</v-icon>
            </v-btn>

            <v-btn
							v-if="allowMultiplePurchase"
              slot="increase-button"
              icon
              @click="increaseQuantity()"
            >
              <v-icon large color="primary">mdi-plus</v-icon>
            </v-btn>

            <v-btn icon slot="delete-item" @click="deleteCartItem()">
              <v-icon color="red lighten-1">mdi-delete</v-icon>
            </v-btn>

						<div v-if="setMinimumPurchase > 1" slot="cart-message">
							<p>
								Minimum Purchase: {{ setMinimumPurchase }}
							</p>
						</div>
          </cart-item>
        </v-list>

        <router-link
					slot="checkout-button"
					:to="`/shop/promocode/checkout/${promoSlug}`"
				>
          <base-button
            name="Checkout"
            x-large
            color="#0e6ccd"
            dark
						:disabled="!(checkoutQuantity >= setMinimumPurchase)"
          ></base-button>
        </router-link>
      </template>
      <template v-else>
        <v-list slot="cart-items" three-line dense width="300" height="250">
          <v-row justify="center" align="center" class="fill-height">
            <div class="text-center">
              <v-icon x-large>mdi-cart-off</v-icon>
              <p class="text-center grey--text pt-3">You cart is empty</p>
            </div>
          </v-row>
        </v-list>
      </template>
    </cart-menu-button>

    <base-banner
      :title="banner.title"
      :caption="banner.caption"
      :backgroundImage="banner.image"
      :titleColor="banner.titleColor"
      :captionColor="banner.captionColor"
      :backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
    >
    </base-banner>

    <base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <base-divider></base-divider>

    <div id="content">
      <notes-ordered-list :notes="notes"></notes-ordered-list>

      <div id="steps" class="white sec">
        <base-title
          title="How to get your unlimited plan"
        ></base-title>

        <v-row justify="center" class="pdx-20">
          <step-column
            v-for="(step, key) in steps"
            :key="key"
            :image="step.image"
            :title="step.title"
            :number="key + 1"
						:line="true"
          ></step-column>
        </v-row>
      </div>

      <div id="plan" class="sec">
        <base-title
          title="Get my exclusive Medgate unliconsultation plan"
          caption="With the plan you can access the Medgate Telemedicine Center with a simple phone call. You can consult a doctor without the hassle of going to the hospital and waiting in line for hours."
          size="1"
        ></base-title>

        <strength-row></strength-row>

        <v-row class="pdx-15" justify="center">
          <v-col
            cols="12" sm="6" md="4" lg="4" xl="4"
						class="d-flex"
          >
						<plan-card
							v-if="plan"
              :name="plan.name"
              :price="plan.price"
              :discount="plan.discount"
              :description="plan.description"
              :elevation="12"
              @add="addToCart()"
							:disable="quantity > 0 ? true : false"
            ></plan-card>
						<plan-code-card
							v-else
						></plan-code-card>
          </v-col>
        </v-row>
      </div>

      <div id="testimonial" class="sec white">
        <v-container>
          <base-title
            title="What our happy customers say about the Medgate Unliconsultation Plan"
            size="1"
          ></base-title>

          <v-row justify="center">
            <v-col
              cols="12" sm="6" md="6" lg="6" xl="6"
              v-for="(tes, key) in testimonials"
              :key="key"
							class="d-flex"
            >
              <testimonial-card
                :title="tes.title"
                :description="tes.caption"
                :ratings="tes.ratings"
                :name="tes.name"
              ></testimonial-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
	</div>
</template>

<script>
import StrengthRow from "@/components/shop/StrengthRow.vue";
import PlanCard from "@/components/shop/PlanCard.vue";
import TestimonialCard from "@/components/home/TestimonialCard.vue";
import CartMenuButton from "@/components/shop/CartMenuButton.vue";
import CartItem from "@/components/shop/CartItem.vue";
import NotesOrderedList from "@/components/shop/NotesOrderedList.vue";
import StepColumn from "@/components/shop/StepColumn.vue";
import PlanCodeCard from "@/components/shop/PlanCodeCard.vue";

import Repository from "@/api/repositories";
const ShopPromotionBannersApi = Repository.get("shopPromotionBanners");
const ShopPromotionPlansApi = Repository.get("shopPromotionPlans");
const ShopTestimonialsApi = Repository.get("shopTestimonials");
const ShopPromotionsApi = Repository.get("shopPromotions");

	export default {
		name: "ShopPromo",
		components: {
			StrengthRow,
			PlanCard,
			TestimonialCard,
			CartMenuButton,
			CartItem,
			NotesOrderedList,
			StepColumn,
			PlanCodeCard
		},
		data: () => ({
			promos: [],
			promoSlug: '',
			promoSlugStorage: localStorage.promoSlug,
      promoIdStorage: localStorage.promoId,
			testimonials: [],
			banner: [],
			plans: [],
			notes: [
				"Medgate Unliconsultation Plan is for Philippines residents only since all our Filipino doctors are licensed to practice and prescribe medication in the Philippines only.",
				"The Medgate Unliconsultation Plan is not designed for immediate medical care at the time of purchase.",
				"You will receive the purchase confirmation email within the period of two banking days along with a unique access key and activation code.",
				"Once the account has been activated, the member will be able to access Medgate Philippines’ telemedicine service on demand at any time.",
				"The Medgate Unliconsultation Plan is non-transferrable and can only be used by the assigned account member."
			],
			steps: [
					{
					image: require("@/assets/images/shop_1.png"),
					title: "Fill out the form"
				},
				{
					image: require("@/assets/images/shop_2.png"),
					title: "Pay"
				},
				{
					image: require("@/assets/images/shop_3.png"),
					title: "Wait for the confirmation"
				},
				{
					image: require("@/assets/images/shop_4.png"),
					title: "Activate your access key and activation code"
				}
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Shop Promo",
					link: "/shop",
					active: true
        }
			]
		}),
		async created() {
			// await this.authenticateUrl();
		},
		computed: {
			quantity: function () {
				return this.$store.getters['promoCart/quantity']
			},
			total: function() {
        return this.$store.getters['promoCart/total']
			},
			plan: function() {
        return this.$store.getters['promoCart/plan']
			},
			allowMultiplePurchase: function() {
				return this.promos.other_settings
					? this.promos.other_settings.is_multiple_purchase || false
					: false;
			},
			setMinimumPurchase: function() {
				return this.promos.other_settings
					? this.promos.other_settings.minimum_quantity_purchase || 1
					: 1;
			},
			checkoutQuantity: function() {
				return this.$store.getters['promoCart/quantity'] || null;
			}
		},
		mounted() {
			this.promoSlug = this.$route.params.slug
			this.getPromotionViaSlug();
		},
		methods: {
			async authenticateUrl() {
				try {
					const { data } = await ShopPromotionsApi.get();
					let promos = data.data;
					this.promos = data.data;

					var slugIndex = promos.findIndex(item =>
						item.slug == this.$route.params.slug
					);

					// if url slug is NOT registered in database
					if (slugIndex < 0) {
						// then REDIRECT to "enter promo code" page
						// this.$router.push({ name: 'ShopPromoCode' })

						// redirect to not found page
						this.$router.push({ name: 'NotFound' })
					}

					// if url slug is REGISTERED
					else {
						// first visit of user in promo
						if (!this.promoIdStorage) {
							// save promo id
							localStorage.setItem('promoId', this.promos[slugIndex].id);
						}
						if (!this.promoSlugStorage) {
							// save new promo slug
							localStorage.setItem('promoSlug', this.$route.params.slug);
						}

						// if url slug is different form the saved promo slug
						if (this.promoSlugStorage !== this.$route.params.slug) {
							console.log("REMOVE");
							// remove promo cart item from localStorage
							localStorage.removeItem('promoItem')
							localStorage.removeItem('promoPlan')
							this.$store.commit('promoCart/removeCurrentPlan')
							// save new promo slug
							localStorage.setItem('promoSlug', this.$route.params.slug);
							// save new promo id
							localStorage.setItem('promoId', this.promos[slugIndex].id);
							location.reload();
						}

						this.getShopPromotionPlans(this.promos[slugIndex].id);
						this.getShopTestimonials();
						await this.getShopPromotionBanner(this.promos[slugIndex].id);
						this.setHeaderColor();

						// but user visited the page WTIHOUT code input
						// or url slug id is DIFFERENT from the saved localStorage promo id
						// if (!this.promoIdStorage || promos[slugIndex].id != this.promoIdStorage) {
							// then REDIRECT to "enter promo code" page
							// this.$router.push({ name: 'ShopPromoCode' })
						// }
						// else {
						// 	this.getShopPromotionPlans();
						// 	this.getShopTestimonials();
						// 	await this.getShopPromotionBanner();
						// 	this.setHeaderColor();
						// }
					}

					console.log('[shop-promos]', promos);
				}
				catch(error) {
					console.log(error);
				}
			},
			setHeaderColor() {
				if (this.banner.backgroundColor)
					this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
				else
					this.$store.commit('page/defaultHeaderColor')
			},
			async getShopPromotionBanner(id) {
				try {
					const { data } = await ShopPromotionBannersApi.get(id);

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let apiData = data.data[0];

						let buttons = apiData.buttons.map(button => {
							return {
								name: button.label,
								icon: button.image,
								link: button.redirect,
								color: JSON.parse(button.styling).color
							}
						});

						let banner = {
							buttons: buttons,
							image: apiData.background_image.main,
							caption: apiData.caption,
							title: apiData.title,
							titleColor: apiData.styles.titleColor,
							captionColor: apiData.styles.captionColor,
							backgroundColor: apiData.styles.backgroundColor
						}

						this.banner = banner;
					}

					console.log('[shop-promo-banner]', data, this.banner);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopPromotionPlans(id) {
				try {
					const { data } = await ShopPromotionPlansApi.get(id);

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let plans = data.data.map(plan => {
							var details = {
								id: plan.id,
								name: plan.name,
								price: plan.price,
								discount: plan.discount,
								description: plan.description,
								maxDependents: plan.no_key_generate
							}

							if (plan.other_details)
									details.member = plan.other_details.applyDetails
										? parseInt(plan.other_details.amountPerHousehold)
										: null
							else
								details.member = null

							return details
						});

						this.plans = plans;
					}

					console.log('[shop-promo-plans]', data, this.plans);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopTestimonials() {
				try {
					const { data } = await ShopTestimonialsApi.get();

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let testimonials = data.data.map(tes => {
							return {
								name: tes.name,
								title: tes.title,
								ratings: parseInt(tes.ratings),
								caption: tes.caption
							}
						});

						this.testimonials = testimonials;
					}

					console.log('[shop-testimonials]', data, this.testimonials);
				}
				catch(error) {
					console.log(error);
				}
			},
			addToCart() {
				var item = {
          description: this.plan.description,
					discount: this.plan.discount,
					id: this.plan.id,
					name: this.plan.name,
					price: this.plan.price,
					quantity: 1,
					member: this.plan.member,
					memberQuantity: 0,
					maxDependents: this.plan.no_key_generate
				}

				if (this.plan.other_details)
						item.member = this.plan.other_details.applyDetails
							? parseInt(this.plan.other_details.amountPerHousehold)
							: null
				else
					item.member = null

				this.$store.commit('promoCart/setItem', item);
				console.log('promo-item', item);
			},
			deleteCartItem() {
				console.log("before", this.plan)
				this.$store.commit('promoCart/deleteItem')
				console.log("after", this.plan)
			},
			increaseQuantity() {
        this.$store.commit('promoCart/increaseQuantity')
      },
      decreaseQuantity() {
        this.$store.commit('promoCart/decreaseQuantity')
      },
			async getPromotionViaSlug() {
				let slug = this.$route.params.slug
				await ShopPromotionsApi
					.getViaSlug(slug)
					.then(async response => {
						this.promos = response.data.data;

						// first visit of user in promo
						if (!this.promoIdStorage) {
							// save promo id
							localStorage.setItem('promoId', this.promos.id);
						}
						if (!this.promoSlugStorage) {
							// save new promo slug
							localStorage.setItem('promoSlug', this.$route.params.slug);
						}

						// if url slug is different form the saved promo slug
						if (this.promoSlugStorage !== this.$route.params.slug) {
							console.log("REMOVE");
							// remove promo cart item from localStorage
							localStorage.removeItem('promoItem')
							localStorage.removeItem('promoPlan')
							this.$store.commit('promoCart/removeCurrentPlan')
							// save new promo slug
							localStorage.setItem('promoSlug', this.$route.params.slug);
							// save new promo id
							localStorage.setItem('promoId', this.promos.id);
							location.reload();
						}

						this.getShopPromotionPlans(this.promos.id);
						this.getShopTestimonials();
						await this.getShopPromotionBanner(this.promos.id);
						this.setHeaderColor();
					})
					.catch(error => {
						console.log({ error });
						this.$router.push({ name: 'NotFound' });
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
</style>
